import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import {
  Connector,
  StyledCaptions,
  SizedCaptions,
} from 'components/VerticalStepper/styles';
import StepIcon from 'components/VerticalStepper/StepIcon';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    rootStepper: {
      flexDirection: 'column-reverse',
      padding: 0,
    },
    stepContent: {
      marginTop: 0,
      border: 'none',
      marginLeft: 6,
    },
  }),
);

const VerticalLinearStepper = ({
  sinistreDetails,
}: {
  sinistreDetails: {
    title: string;
    subtitle: string;
    actualDate: any;
    timelineState: string;
    shareName: string;
    status: string;
    description: string;
  }[];
}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Stepper
        classes={{ root: classes.rootStepper }}
        activeStep={
          sinistreDetails[sinistreDetails.length - 1].status === 'DONE'
            ? sinistreDetails.length
            : sinistreDetails.length - 1
        }
        orientation="vertical"
        connector={<Connector />}
      >
        {sinistreDetails.map((detail: any, index: number) => (
          <Step active={true} key={index}>
            <StepLabel StepIconComponent={StepIcon}>
              <SizedCaptions weight="400">{detail.title}</SizedCaptions>
            </StepLabel>

            <StepContent classes={{ root: classes.stepContent }}>
              {' '}
              <StyledCaptions marginBottom={16} color="#838EA4" weight="400">
                {' '}
                {detail.description}
              </StyledCaptions>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};
export default VerticalLinearStepper;
